module.exports = __webpack_public_path__ + "img/mail.6ea854dc.svg";